<template>
    <div id="app" v-cloak v-show="isShow">
        <div class="" v-if="app_show"></div>
        <div v-if="showcompon">
            <Navigahome ref="nav" :isActive="isActive" @clicfun='clicfun' v-show="!dispute"></Navigahome>
        </div>
        <base-crumbs v-if="$store.state.app.is_show" :crumbs="[]"></base-crumbs>
        <div class="height">
            <router-view></router-view>
        </div>
        <div v-if="showcompon">
            <Footer v-show="!dispute"></Footer>
        </div>
        <div v-if="showcompon">
            <Alert v-show="!dispute"></Alert>
        </div>
        <div v-if="showcompon">
            <right v-show="!dispute"></right>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {LoginStatus} from 'hanzi-vue-package';
    import Navigahome from './components/Navigahome.vue';
    import baseNav from '@components/Navigation';
    import Footer from './components/Footer.vue'
    import Alert from '@components/Loginr';
    import right from '@components/Right.vue';

    export default {
        data() {
            return {
                scro: false,
                isActive: 0,
                isShow: false,  //页面是否显示
                name: tools.cache.get('nickname'),
                app_show: true,
                donw_url: '',
                dispute:false,
                showcompon:false
            }
        },
        created() {
            let that = this;

            /*
                **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
                **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
                **
            */
            tools.vue.mixin({
                /* 全局方法 */
                methods: {
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        return !val ? '/static/images/zimu.png.png' : val + (!size ? '' : size);
                    },

                    /* 跳转 */
                    toUrl: function (url, val) {
                        tools.router.push({path: url, query: val});
                    },
                    checkstatus(val) {
                        let text = '';
                        switch(val) {
                            case 0:
                                text = '未支付';
                            break;
                            case 1:
                                text = '已付款';
                            break;
                            case 2:
                                text = '已发货';
                            break;
                            case 3:
                                text = '退款中';
                            break;
                            case 4:
                                text = '已退款';
                            break;
                            case 5:
                                text = '交易成功';
                            break;
                            case 6:
                                text = '交易关闭';
                            break;
                        }
                        return text;
                    },
                    checkpay(val) {
                        let text = '';
                        switch(val) {
                            case 1:
                                text = '微信';
                            break;
                            case 2:
                                text = '支付宝';
                            break;
                            case 3:
                                text = '苹果支付';
                            break;
                        }
                        return text;
                    },
                },
                /* 全局过滤 */
                filters: {
                    /* 默认图片过滤 */
                    thumbnail: function (val, size) {
                        return !val ? '/static/images/zimu.png.png' : val + (!size ? '' : size);
                    },
                      timeTrana:function(inputTime)
                      {
                            var date = new Date();
                            date.setTime(inputTime * 1000);
                            var y = date.getFullYear();
                            var m = date.getMonth() + 1;
                            m = m < 10 ? ('0' + m) : m;
                            var d = date.getDate();
                            d = d < 10 ? ('0' + d) : d;
                            var h = date.getHours();
                            h = h < 10 ? ('0' + h) : h;
                            var minute = date.getMinutes();
                            var second = date.getSeconds();
                            minute = minute < 10 ? ('0' + minute) : minute;
                            second = second < 10 ? ('0' + second) : second;
                            return y + '-' + m + '-' + d
                      //      +' '+h+':'+minute+':'+second;
                      },
                      timeTran:function(inputTime)
                      {
                            var date = new Date();
                            date.setTime(inputTime * 1000);
                            var y = date.getFullYear();
                            var m = date.getMonth() + 1;
                            m = m < 10 ? ('0' + m) : m;
                            var d = date.getDate();
                            d = d < 10 ? ('0' + d) : d;
                            var h = date.getHours();
                            h = h < 10 ? ('0' + h) : h;
                            var minute = date.getMinutes();
                            var second = date.getSeconds();
                            minute = minute < 10 ? ('0' + minute) : minute;
                            second = second < 10 ? ('0' + second) : second;
                            return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
                      },
                    /* 时间转换 */
                    timeTranqw: function (value) {
                        return parseInt(value) === 0 ? '-' : tools.date('Y-m-d H:i:s', value);
                    },
                      timeTranq:function(inputTime)
                      {
                            var date = new Date();
                            date.setTime(inputTime * 1000);
                            var y = date.getFullYear();
                            var m = date.getMonth() + 1;
                            m = m < 10 ? ('0' + m) : m;
                            var d = date.getDate();
                            d = d < 10 ? ('0' + d) : d;
                            var h = date.getHours();
                            h = h < 10 ? ('0' + h) : h;
                            var minute = date.getMinutes();
                            var second = date.getSeconds();
                            minute = minute < 10 ? ('0' + minute) : minute;
                            second = second < 10 ? ('0' + second) : second;
                            return h+':'+minute+':'+second;
                      },
                    /* 自定时间格式转换 */
                    setTimeTran: function (value, type) {
                        return parseInt(value) === 0 ? '-' : tools.date(type, value);
                    },

                    /* 价格转换--保留两位小数 */
                    toFixedPrice: function (value) {
                        return value ? (parseInt(value) / 100).toFixed(2) : '0';
                    },

                    /* 价格转换 */
                    toPrice: function (value) {
                        return value ? (parseInt(value) / 100) : '0';
                    }
                }
            });

        },
        name: 'app',
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'isLinkChange'
        },
        
        methods: {
            /*下载app*/
            downUrl() {
                let that = this;
                var a = document.createElement('a');
                a.setAttribute('target', '_blank');
                a.setAttribute('href', that.donw_url)
                if (document.all) {
                    a.click();
                } else {
                    var evt = document.createEvent("MouseEvents");
                    evt.initEvent("click", true, true);
                    a.dispatchEvent(evt);
                }

                a.remove();
            },

            doWnload() {

            },
            clicfun(index) {
            },
            /* 连接变化时执行 */
            isLinkChange: function () {
                var that = this;
                if (that.$route.path == '/' || that.$route.path == '/index') {
                    that.scro = false;
                    that.app_show = false
                } else {
                    that.app_show = true;
                    that.scro = false;
                }
                if(that.$route.path=='/dispute' || that.$route.path == '/webim/webim'){
                    that.dispute = true
                }else{
                    that.dispute = false
                }
                if (that.$route.path != '/practice/test' && that.$route.path != '/practice/answercard' && that.$route.path!='/practice/paper'&& that.$route.path !='/practice/analysis') {
                    tools.cache.del('index_');
                      tools.cache.del('Blist');
                      tools.cache.del('Alist');
                    tools.cache.del('time_num');
                    tools.cache.del('indexb_');
                    tools.cache.del('testList');
                    tools.cache.del('testListb');
                }
                //console.log('改变了导航:',this.$route);
                if(that.$refs.nav) {
                     for (let i of that.$refs.nav.$data.menu_list) {
                        //              	console.log(i.urls,location.pathname,that.$refs.nav.$data.menu_list.indexOf(i),111)
                        if (location.pathname == i.urls) {
                            that.isActive = that.$refs.nav.$data.menu_list.indexOf(i);
                        }
                    }
                    if(location.pathname == '/line/linedetail') {
                        that.isActive = 1
                    }
                }
               
                if (!that.isHavePage()) {
                    return;
                }

                that.name = tools.cache.get('nickname'); //用户名

                //判断是否为登陆页
                // if(!(that.$route.path == '/login' || that.$route.path == '/register' || tools.noLoginUrl.isUrl(that.$route.path))){
                //
                //     //每次跳页面都会验证登录是否过期
                //     LoginStatus.check({
                //         type:  'login'
                //     });
                //
                // }
                if(that.$route.path == '/webshopping/shopping_cart' || that.$route.path == '/webshopping/shopping_price') {
                    $(".height").css("background", '#fff')
                } else {
                    $(".height").css("background", '#f1f1f1')
                }
                that.$nextTick(() => {
                    setTimeout(() => {
                        $(".height").css("min-height", $(window).height() - 110 + 'px')
                    }, 10);
                });
                that.isShow = true;
            },

            /* 判断页面是否存在 */
            isHavePage: function () {

                //首页跳过
                if (this.$route.path == '/') {
                    return true;
                }

                //首页跳过
                if (this.$route.path == '/404') {
                    this.isShow = true;
                    return false;
                }
                //注册页跳过
                if (this.$route.path == '/register') {
                    this.isShow = true;
                    return false;
                }

                //不存在自动跳转到404页面
                if (this.$route.matched.length < 1) {
                    tools.router.replace('/404');
                    return false;
                }

                this.isfullScreen = false;
                return true;
            },

            navBlock: function (type) {
                this.isNavBlock = type;
            },

            /* 注销登录 */
            logOut: function () {
                tools.alert.loading();
                tools.ajax({
                    url: '/api/login/out',
                    ajaxData: {},
                    successFun: function (res) {
                        tools.alert.closeLoading();
                        tools.cache.del('nickname');
                        tools.cache.del('Authorization');
                        tools.cache.set('isLogin', '0');
                        that.toUrl('/login');
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.closeLoading();
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'DELETE'
                });

            },

            /* 跳转 */
            toUrl: function (url, val) {
                tools.router.push({path: url, query: val});
            }
        },
        components: {
            baseNav,
            Navigahome,
            Footer,
            Alert,
            right
        },
        beforeCreate() {

        },
        mounted() {
            let that = this;
            
            $(".height").css("min-height", $(window).height() - 103 + 'px');
            $(window).bind("scroll", function () {
                if ($(window).scrollTop() >= 400) {
                    that.scro = true;
                } else {
                    that.scro = false;
                }
            });
            if(window.sessionStorage.getItem("Authorization")) {
                if( window.location.pathname == '/littlevideo/little_playvideo') {
                    this.showcompon = false 
                } else {
                    this.showcompon = true
                }
                that.isHavePage();
                that.doWnload();
            } else {
                tools.ajax({
                    url: '/api/init',
                    ajaxData: {},
                    successFun: function (res) {
                        if( window.location.pathname == '/littlevideo/little_playvideo') {
                            that.showcompon = false 
                        } else {
                            that.showcompon = true
                        }
                        tools.cache.set('Authorization', res.token);
                    
                    },
                    errorFun: function (error) {
                        log.error('获取签名失败');
                    },
                    type: 'GET'
                });
            }
            
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    @import "./assets/sass/common/tool";

    .yd-backtop {
        position: fixed;
        width: 60px !important;
        height: 60px !important;
        border-radius: 0 !important;
        border: none !important;
        right: 25px !important;
        bottom: 141px !important;
        z-index: 55;
        cursor: pointer;
        transition: all .5;
        .yd-backtop-top {
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: center;
            width: 100%;
            height: 24px;
            font-size: 12px;
            color: #FFFFFF;
            height: 24px;
            background: #898989;
        }
        .yd-phone {
            width: 100%;
            height: 36px;
            background: #999999;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                width: 16px;
            }
        }
        &:hover {
            .yd-backtop-top {
                background: #f69b96;
            }
            .yd-phone {
                background: #f7a8a4;
            }
        }
    }

    .yd-app {
        right: 25px !important;
        bottom: 70px !important;
    }
</style>



// WEBPACK FOOTER //
// App.vue?22571eef